const permitir_consultar_matricula_diaria_por_escola = {
  path: "/permitir-consultar-matricula-diaria-por-escola",
  redirect: "/permitir-consultar-matricula-diaria-por-escola",
  meta: {
    breadCrumb: "Processo de Matrículas - Retrato de Matrícula Diária",
  },
  children: [
    {
      path: "/permitir-consultar-matricula-diaria-por-escola",
      name: "permitir-consultar-matricula-diaria-por-escola",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEscola/PermitirConsultarMatriculaDiariaPorEscola.vue"
        ),
    },
    {
      path: "/permitir-consultar-matricula-diaria-por-escola/escola/:id",
      name: "permitir-consultar-matricula-diaria-por-escola-visualizar-escola",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEscola/PermitirConsultarMatriculaDiariaPorEscolaVisualizarEscola.vue"
        ),
    },
    {
      path: "/permitir-consultar-matricula-diaria-por-escola/ensino/:id",
      name: "permitir-consultar-matricula-diaria-por-escola-visualizar-ensino",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEscola/PermitirConsultarMatriculaDiariaPorEscolaVisualizarEnsino.vue"
        ),
    },
    {
      path: "/permitir-consultar-matricula-diaria-por-escola/turno/:id",
      name: "permitir-consultar-matricula-diaria-por-escola-visualizar-turno",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEscola/PermitirConsultarMatriculaDiariaPorEscolaVisualizarTurno.vue"
        ),
    },
    {
      path: "/permitir-consultar-matricula-diaria-por-escola/fase/:id",
      name: "permitir-consultar-matricula-diaria-por-escola-visualizar-fase",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEscola/PermitirConsultarMatriculaDiariaPorEscolaVisualizarFase.vue"
        ),
    },
  ],
};

export { permitir_consultar_matricula_diaria_por_escola };
